<div class="ui-g-12">
  <app-error-messages [api_result]="this.payment_data.payment_start_api_result">
  </app-error-messages>
</div>

<ng-container *ngIf="this.payment_data.payment_start_api_result.Posting">
  <div class="ui-g-12">
    <h3>Fetching your order details...</h3>
    <app-loading type="LOADING_DATA"></app-loading>
  </div>
</ng-container>

<ng-container *ngIf="
    !this.payment_data.payment_start_api_result.Posting &&
    this.payment_data.payment_start_api_result.PromiseResult.success
  ">
  <div class="ui-g-12">
    <div class="ui-g-12">
      <img class="img-responsive logo-img-payment" alt="eGlobalDoctors" [src]="this.logo_url" />
    </div>
    <div class="ui-g-12">
      <div class="ui-g-1"></div>
      <div class="ui-g-10 ui-sm-12">
        <div class="ui-g-12 text-center">
          <p class="common_txt1" style="font-weight: bold">Payment Invoice</p>
        </div>
        <div class="ui-g-12 text-center">
          <div class="table-responsive">
            <table class="table table-bordered-payment common_txt" id="pdfcontent"
              style="border-radius: 5px; word-wrap: break-word">
              <thead>
                <tr style="font-weight: bold">
                  <th class="ui-g-8">Description</th>
                  <th class="ui-g-4" style="white-space: nowrap">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                    let item of this.payment_data.order_data.basket.item_list
                  ">
                  <td class="ui-g-8">
                    {{ item.name }}
                  </td>
                  <td class="ui-g-4 text-center notranslate" style="white-space: nowrap">
                    {{
                    this.renderAmount(
                    item.raw_amount,
                    this.payment_data.order_data.basket.currency_type
                    )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="ui-g-8">
                    <p style="font-weight: bold">Total:</p>
                  </td>
                  <td class="ui-g-4 egd-color" style="font-weight: bold; white-space: nowrap">
                    <p class="notranslate">
                      {{
                      this.renderAmount(
                      this.payment_data.order_data.basket.raw_total,
                      this.payment_data.order_data.basket.currency_type
                      )
                      }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="ui-g-12 ui-sm-12 text-center">
        <!-- <div class="ui-g-12 text-center">
                    <h3 style="font-weight: bold;">
                        Payment Information
                    </h3>
                </div> -->
        <ng-container *ngIf="this.payment_data.payment_start_api_result.Posting">
          <div class="ui-g-12">
            <app-loading type="LOADING_DATA"></app-loading>
          </div>
        </ng-container>
        <ng-container *ngIf="
            !this.payment_data.payment_start_api_result.Posting &&
            this.payment_data.payment_start_api_result.PromiseResult.success
          ">
          <div class="ui-g-12">
            <ng-container *ngIf="this.payment_data.is_paypal">
              <div id="dropin-container"></div>
              <button pButton pRipple name="pay_by_paypal" label="Continue to Payment" type="submit"
                [disabled]="isPosting()" (click)="payByPaypal()" style="padding: 5px; border-radius: 5px"></button>
            </ng-container>

            <ng-container *ngIf="this.payment_data.is_razorpay">
              <button pButton pRipple name="pay_by_razorpay" label="Continue to Payment" type="submit"
                [disabled]="isPosting()" (click)="payByRazorpay()" style="padding: 5px; border-radius: 5px"></button>
            </ng-container>
            <app-error-messages [api_result]="this.payment_data.payment_start_api_result"></app-error-messages>
            <div class="ui-g-12">
              {{ this.payment_data.order_data.basket.disclaimer }}
            </div>
          </div>
        </ng-container>
        <div class="ui-g-12">
          <app-error-messages [api_result]="this.payment_data.payment_start_api_result"></app-error-messages>
          <app-error-messages [api_result]="this.payment_data.transaction_submit_api_result"></app-error-messages>
        </div>
        <div class="ui-g-12">
          <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER"></app-loading>
        </div>
      </div>
    </div>
  </div>
</ng-container>